"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urlLib = require("url-lib");

var _get = _interopRequireDefault(require("lodash/get"));

var _pull = _interopRequireDefault(require("lodash/pull"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));

var _http = require("js-utils/http");

var _janus = require("@eb/janus");

var _pathUtils = require("@eb/path-utils");

var _performanceMonitor = require("@eb/performance-monitor");

var _siteAnalytics = require("@eb/site-analytics");

var _FollowNotification = _interopRequireDefault(require("../components/FollowNotification"));

var _FollowGDPRModal = _interopRequireDefault(require("../components/FollowGDPRModal"));

var _FollowLoginModal = _interopRequireDefault(require("../components/FollowLoginModal"));

var _organizer = require("../api/organizer");

var _user = require("../api/user");

var _transformations = require("../api/transformations");

var _state = require("../utils/state");

var _modals = require("../utils/modals");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var addFollow = function addFollow(HighLevelComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(Follow, _Component);

    var _super = _createSuper(Follow);

    function Follow(props) {
      var _this;

      _classCallCheck(this, Follow);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "_hydrateOrganizerData", function () {
        var organizers = _this.state.organizers;
        (0, _organizer.getOrganizers)(organizers).catch(_this._handleError.bind(null, '', _constants.ERROR_ORG_INFO)).then(function (response) {
          if (_this._isMounted && response) {
            var _response$organizers = response.organizers,
                organizerResponse = _response$organizers === void 0 ? [] : _response$organizers;

            _this.setState(function (prevState) {
              return {
                organizerData: _objectSpread(_objectSpread({}, prevState.organizerData), (0, _transformations.normalizeOrganizers)(organizerResponse))
              };
            }, _this.updateSubscribers);

            _this._shouldFollowOrganizerFromCookie();
          }
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_shouldFollowOrganizerFromCookie", function () {
        var organizerData = _this.state.organizerData;
        var organizerIdFromCookie = (0, _modals.getOrganizerIdFromCookie)();

        if (organizerIdFromCookie && organizerData[organizerIdFromCookie] && !organizerData[organizerIdFromCookie].followedByYou && organizerIdFromCookie === organizerData[organizerIdFromCookie].id) {
          _this._checkAuthenticatedStatusWithCache().then(function (isAuthenticated) {
            if (isAuthenticated) {
              _this._followOrganizer(organizerIdFromCookie);

              _this._clearOrganizerCookie();
            }
          });
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_clearOrganizerCookie", function () {
        (0, _modals.expireOrganizerCookie)();
      });

      _defineProperty(_assertThisInitialized(_this), "_followOrganizer", function (organizerId) {
        return (0, _organizer.followOrganizer)(organizerId).then(function (response) {
          if (_this._isMounted) {
            _this._updateFollowState(organizerId, response);

            _this._trackFollowEvent(organizerId);

            _this._informUser(organizerId);
          }
        }).catch(function () {
          return _this._handleError(organizerId, _constants.ERROR_FOLLOW);
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_unFollowOrganizer", function (organizerId) {
        return (0, _organizer.unfollowOrganizer)(organizerId).then(function (response) {
          _this._updateFollowState(organizerId, response);

          _this._trackUnfollowEvent(organizerId);
        }).catch(function () {
          return _this._handleError(organizerId, _constants.ERROR_UNFOLLOW);
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_updateFollowState", function (organizerId) {
        var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var followedByYou = response.followedByYou;

        if (followedByYou !== undefined) {
          _this.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              organizerData: _objectSpread(_objectSpread({}, prevState.organizerData), {}, _defineProperty({}, organizerId, _objectSpread(_objectSpread({}, prevState.organizerData[organizerId]), {}, {
                followedByYou: followedByYou
              })))
            });
          }, _this.updateSubscribers);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleError", function (organizerId, action) {
        _this._renderNotification(organizerId, action);
      });

      _defineProperty(_assertThisInitialized(_this), "_informUser", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(organizerId) {
          var _this$props, isGDPRCountry, userId, _this$props$launchCom, launchCommSettingsFollowAction, shouldShowModal;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props = _this.props, isGDPRCountry = _this$props.isGDPRCountry, userId = _this$props.userId, _this$props$launchCom = _this$props.launchCommSettingsFollowAction, launchCommSettingsFollowAction = _this$props$launchCom === void 0 ? false : _this$props$launchCom;
                  _context.next = 3;
                  return (0, _modals.shouldShowGDPRModal)(isGDPRCountry, userId, launchCommSettingsFollowAction);

                case 3:
                  shouldShowModal = _context.sent;

                  _this._renderNotification(organizerId);

                  if (shouldShowModal) {
                    _this.trackGAEvent(_this._getGAEventParamsFor('gdprModal', organizerId));

                    _this._renderGDPRModal(organizerId);
                  }

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());

      _defineProperty(_assertThisInitialized(_this), "_trackFollowEvent", function (organizerId) {
        _this.trackGAEvent(_this._getGAEventParamsFor('follow', organizerId));

        (0, _performanceMonitor.setCustomData)(_constants.FOLLOW_DONE_CUSTOM_METRIC_DATA, 1);
        (0, _janus.logCheckpointViaAjax)('follow_organizer');
      });

      _defineProperty(_assertThisInitialized(_this), "_trackFollowAttempt", function (organizerId) {
        _this.trackGAEvent(_this._getGAEventParamsFor('followAttempt', organizerId));
      });

      _defineProperty(_assertThisInitialized(_this), "_trackUnfollowEvent", function (organizerId) {
        _this.trackGAEvent(_this._getGAEventParamsFor('unfollow', organizerId));
      });

      _defineProperty(_assertThisInitialized(_this), "_trackViewOrganizer", function (organizerId) {
        _this.trackGAEvent(_this._getGAEventParamsFor('viewOrganizer', organizerId));
      });

      _defineProperty(_assertThisInitialized(_this), "_getGAEventParamsFor", function (action, organizerId) {
        var _this$props2 = _this.props,
            gaCategory = _this$props2.gaCategory,
            gaActionSuffix = _this$props2.gaActionSuffix;
        var organizerData = _this.state.organizerData;
        var actionName = _constants.actionToGAActionMap[action];
        var dimensions = gaActionSuffix ? {
          dimension4: gaActionSuffix
        } : {};
        return {
          action: actionName,
          category: gaCategory,
          label: (0, _get.default)(organizerData, [organizerId, 'name']),
          dimensions: dimensions
        };
      });

      _defineProperty(_assertThisInitialized(_this), "updateSubscribers", function () {
        var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state;

        _this.subscriptions.forEach(function (cb) {
          cb(nextState);
        });
      });

      _defineProperty(_assertThisInitialized(_this), "subscribeToContextUpdates", function (cb) {
        _this.subscriptions = [].concat(_toConsumableArray(_this.subscriptions), [cb]);
        cb(_this.state);
      });

      _defineProperty(_assertThisInitialized(_this), "unsubscribeFromContextUpdates", function (cbToUnsub) {
        _this.subscriptions = _this.subscriptions.filter(function (cb) {
          return cb !== cbToUnsub;
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_handleLoggedOutFollow", function (organizerId) {
        var loginOptions = _this.props.loginOptions;
        var organizerData = _this.state.organizerData;
        var referrer = loginOptions.referrer || (0, _pathUtils.getUrlPath)();

        if (loginOptions.shouldUseSigninConfirmationRedirect) {
          var url = (0, _urlLib.formatUrl)(_constants.LOGIN_CONFIRMATION_PATH, {
            referrer: referrer,
            organizerId: organizerId,
            action: 'followOrganizer',
            title: (0, _get.default)(organizerData, [organizerId, 'name']),
            image: (0, _get.default)(organizerData, [organizerId, 'profilePicture'])
          });

          if (loginOptions.shouldOpenNewTab) {
            return window.open(url);
          }

          return (0, _http.setWindowLocation)(url);
        }

        return _this._renderLoginModal(organizerId);
      });

      _defineProperty(_assertThisInitialized(_this), "_checkAuthenticatedStatusWithCache", function () {
        var _this$state = _this.state,
            isAuthenticatedFromState = _this$state.isAuthenticated,
            userIdFromState = _this$state.userId;
        var authenticatedStatusIsDefined = (0, _isBoolean.default)(isAuthenticatedFromState);
        var userLoggedOut = authenticatedStatusIsDefined && !isAuthenticatedFromState && !userIdFromState;
        var userLoggedInWithData = authenticatedStatusIsDefined && isAuthenticatedFromState && userIdFromState;

        if (userLoggedInWithData || userLoggedOut) {
          return Promise.resolve(isAuthenticatedFromState);
        }

        return (0, _user.getUser)().then(function (_ref2) {
          var id = _ref2.id;

          if (_this._isMounted) {
            return _this._setAuthentication(true, id);
          }

          return null;
        }).catch(function (_ref3) {
          var response = _ref3.response;

          if (response.status === _constants.UNAUTHORIZED_ERROR_CODE) {
            return _this._setAuthentication(false);
          }

          _this._renderNotification('', _constants.ERROR_USER_INFO);

          return _this._setAuthentication(undefined);
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_setAuthentication", function (isAuthenticated, userId) {
        _this.setState({
          isAuthenticated: isAuthenticated,
          userId: userId
        });

        return isAuthenticated;
      });

      _defineProperty(_assertThisInitialized(_this), "_handleOnFollow", function (organizerId) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            callback = _ref4.callback;

        _this._checkAuthenticatedStatusWithCache().then(function (isAuthenticated) {
          if (isAuthenticated) {
            _this._followOrganizer(organizerId).then(function () {
              callback && callback();
            });
          } else {
            _this._trackFollowAttempt(organizerId);

            _this._handleLoggedOutFollow(organizerId);
          }
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_handleOnUnFollow", function (organizerId) {
        var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            callback = _ref5.callback;

        _this._unFollowOrganizer(organizerId).then(function () {
          callback && callback();
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_handleRemoveOrganizer", function (organizerId) {
        _this._removeOrganizer(organizerId);
      });

      _defineProperty(_assertThisInitialized(_this), "_handleViewOrganizer", function (organizerId) {
        _this._trackViewOrganizer(organizerId);
      });

      _defineProperty(_assertThisInitialized(_this), "_removeOrganizer", function (organizerId) {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            organizerData: (0, _omit.default)(prevState.organizerData, organizerId),
            organizers: (0, _pull.default)(prevState.organizers, organizerId)
          });
        }, _this.updateSubscribers);

        _this.trackGAEvent(_this._getGAEventParamsFor('dismissOrganizer', organizerId));
      });

      _defineProperty(_assertThisInitialized(_this), "_renderLoginModal", function (organizerId) {
        var loginOptions = _this.props.loginOptions;
        var organizerData = _this.state.organizerData;
        var organizer = (0, _get.default)(organizerData, [organizerId]);

        if (organizer) {
          (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(_FollowLoginModal.default, {
            organizerId: organizerId,
            organizerName: (0, _get.default)(organizer, 'name'),
            trackGAEvent: _this.trackGAEvent,
            organizerProfilePicture: (0, _get.default)(organizer, 'profilePicture', ''),
            getSharedState: function getSharedState() {
              return _this.state;
            },
            setSharedState: function setSharedState(newState) {
              _this.setState(newState);
            },
            onChangeSharedState: function onChangeSharedState(cb) {
              _this.subscribeToContextUpdates(cb);
            },
            referrer: loginOptions.referrer,
            shouldOpenNewTab: loginOptions.shouldOpenNewTab
          }), (0, _modals.createLoginModalContainer)(), function () {
            _this.setState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                loginModalShown: true
              });
            }, _this.updateSubscribers);
          });
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_renderGDPRModal", function () {
        var _this$props3 = _this.props,
            gaCategory = _this$props3.gaCategory,
            _this$props3$launchCo = _this$props3.launchCommSettingsFollowAction,
            launchCommSettingsFollowAction = _this$props3$launchCo === void 0 ? false : _this$props3$launchCo;
        var userId = _this.state.userId;
        (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(_FollowGDPRModal.default, {
          userId: userId,
          trackGAEvent: _this.trackGAEvent,
          gaCategory: gaCategory,
          getSharedState: function getSharedState() {
            return _this.state;
          },
          setSharedState: function setSharedState(newState) {
            _this.setState(newState);
          },
          onChangeSharedState: function onChangeSharedState(cb) {
            _this.subscribeToContextUpdates(cb);
          },
          launchCommSettingsFollowAction: launchCommSettingsFollowAction
        }), (0, _modals.createGDPRContainer)(), function () {
          _this.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              gdprModalShown: true
            });
          }, _this.updateSubscribers);
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_renderNotification", function (organizerId) {
        var errorActionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(_FollowNotification.default, {
          organizerId: organizerId,
          getSharedState: function getSharedState() {
            return _this.state;
          },
          setSharedState: function setSharedState(newState) {
            _this.setState(newState);
          },
          onChangeSharedState: function onChangeSharedState(cb) {
            _this.subscribeToContextUpdates(cb);
          },
          errorActionType: errorActionType,
          topOffset: _this.props.notificationContainerClassName ? 0 : _constants.GLOBAL_NAV_HEIGHT
        }), (0, _modals.createFollowNotificationContainer)(_this.props.notificationContainerClassName), function () {
          _this.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              followNotificationShown: true
            });
          }, _this.updateSubscribers);
        });
      });

      _this._isMounted = false;
      _this.subscriptions = [];
      _this.state = (0, _state.computeMergedState)((0, _state.getInitialSharedState)(props));

      _this.trackGAEvent = function (gaProperties) {
        return (0, _siteAnalytics.trackEventFromState)({
          gaSettings: props.gaSettings
        }, gaProperties);
      };

      return _this;
    }

    _createClass(Follow, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          subscribeToContextUpdates: this.subscribeToContextUpdates,
          unsubscribeFromContextUpdates: this.unsubscribeFromContextUpdates,
          onFollow: this._handleOnFollow,
          onUnFollow: this._handleOnUnFollow,
          onRemoveOrganizer: this._handleRemoveOrganizer,
          onViewOrganizer: this._handleViewOrganizer
        };
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this._isMounted = true;

        this._hydrateOrganizerData();

        (0, _performanceMonitor.setMark)(_constants.FOLLOW_READY_CUSTOM_METRIC_MARK);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._isMounted = false;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(HighLevelComponent, this.props);
      }
    }]);

    return Follow;
  }(_react.Component), _defineProperty(_class, "propTypes", {
    organizers: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
    // eslint-disable-next-line
    gaSettings: _propTypes.default.object.isRequired,
    gaCategory: _propTypes.default.string.isRequired,
    organizerData: _propTypes.default.objectOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      name: _propTypes.default.string.isRequired,
      url: _propTypes.default.string.isRequired,
      followedByYou: _propTypes.default.bool.isRequired,
      profilePicture: _propTypes.default.string,
      numUpcomingEvents: _propTypes.default.number,
      numFollowers: _propTypes.default.number,
      customDataPoint: _propTypes.default.string
    })),
    isAuthenticated: _propTypes.default.bool,
    isGDPRCountry: _propTypes.default.bool,
    userId: _propTypes.default.string,
    gaActionSuffix: _propTypes.default.string,
    loginOptions: _propTypes.default.shape({
      referrer: _propTypes.default.string,
      shouldOpenNewTab: _propTypes.default.bool,
      shouldUseSigninConfirmationRedirect: _propTypes.default.bool
    }),
    notificationContainerClassName: _propTypes.default.string,
    launchCommSettingsFollowAction: _propTypes.default.bool
  }), _defineProperty(_class, "childContextTypes", {
    subscribeToContextUpdates: _propTypes.default.func,
    unsubscribeFromContextUpdates: _propTypes.default.func,
    onFollow: _propTypes.default.func,
    onUnFollow: _propTypes.default.func,
    onRemoveOrganizer: _propTypes.default.func,
    onViewOrganizer: _propTypes.default.func
  }), _defineProperty(_class, "defaultProps", {
    loginOptions: {}
  }), _temp;
};

var _default = addFollow;
exports.default = _default;
//# sourceMappingURL=addFollow.js.map